export { rem } from "polished";

export const zIndex = {
  negative: -1,
  positive: 1,
  header: 15,
  modalBackground: 20,
  modalContainer: 25,
  modal: 30,
  inputSuggestions: 5,
  selectInputOptions: 3,
};

export const ColorPalette = {
  white: "#ffffff",
  black: "#000000",
  black_300: "#1E1E1E",
  transparent: "rgba(255, 255, 255, 0)",
  grey_700: "#454545",
  grey_600: "#707070",
  grey_500: "#808080",
  grey_400: "#7E7E7E",
  grey_200: "#C4C4C4",
  grey_100: "#E9E9E9",
  blue_800: "#303A4E",
  blue_700: "#3F5785",
  blue_600: "#6796f4",
  blue_500: "#1968D8",
  blue_400: "#135ECA",
  blue_300: "#3372f0",
  blue_200: "#3F8EFE",
  blue_100: "#EBF3FF",
  blue_90: "#E9F3FF",
  blue_50: "#D3E7FF",
  blue_40: "#F6FAFF",
  blue_30: "#F2F8FF",
  red_400: "#E60000",
  red_100: "#FFAB9F",
  green: "#7EDD42",
  grey: "#B3C1DA",
  grey_2: "#879bb3",
  grey_3: "#D9D9D9",
  grey_blue: "rgba(233, 243, 255, 0.12)",
  orange_700: "#FFA500",
};

export const baseFontSize = "16px";

export const fontWeight = {
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
};

export const SmallMobileBreakpoint = 480;
export const MobileBreakpoint = 768;
export const TabletBreakpoint = 992;
export const DesktopMediumBreakpoint = 1200;
export const DesktopBreakpoint = 1280;
export const DesktopLargeBreakpoint = 1440;

export const Breakpoint = {
  smallMobile: `@media(max-width: ${SmallMobileBreakpoint}px)`,
  mobile: `@media(max-width: ${MobileBreakpoint}px)`,
  smallTablet: `@media(max-width: ${TabletBreakpoint - 1}px)`,
  tablet: `@media(max-width: ${DesktopBreakpoint - 1}px)`,
  desktopMedium: `@media(max-width: ${DesktopMediumBreakpoint - 1}px)`,
  desktop: `@media(min-width: ${DesktopBreakpoint}px)`,
  desktopLarge: `@media(max-width: ${DesktopLargeBreakpoint - 1}px)`,
  tabletLaptopOffersPage: `@media(min-width: 630px) and (max-width: 1421px)`,
  tabletOffersPage: `@media(min-width: 450px) and (max-width: 630px)`,
  mobileOffersPage: `@media(max-width: 1421px)`,
};
